import store from '../store'

import Home from '../pages/home.vue'
import Portfolio from '../pages/portfolio.vue'
import About from '../pages/about.vue'
import Contact from '../pages/contact.vue'
import Instagram from '../pages/instagram.vue'
import Login from '../pages/login.vue'
import PortfolioPrivate from '../pages/portfolio-private.vue'

export default [{
  path: '/en',
  name: 'home',
  component: Home,
  meta: {
    title: window.Laravel.static_seo["/"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/"].description
    },
      // {
      //   property: 'og:description',
      //   content: window.Laravel.static_seo["/"].description
      // }
    ],
    background: '#f1f1f1',
    classes: "full-page"
  },
  beforeEnter: (to, from, next) => {
    store.dispatch("getHomePhotos")
      .then(function (response) {
        next()
      })
      .catch(function (error) {
        return error
      })
  }
}, {
  path: '/en/portfolio/:category?',
  name: 'portfolio',
  component: Portfolio,
  meta: {
    title: window.Laravel.static_seo["/portfolio"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/portfolio"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/portfolio"].description
    }
    ],
    classes: "full-page",
  },
  beforeEnter: (to, from, next) => {
    store.dispatch("getPortfolio")
      .then(function (response) {
        if (!to.params.category) {
          next({
            name: 'portfolio',
            params: {
              category: store.getters.defaultPortfolioCategory
            }
          })
        } else {
          next()
        }
      })
      .catch(function (error) {
        return error
      })
  }
}, {
  path: '/en/about',
  name: 'about',
  component: About,
  meta: {
    title: window.Laravel.static_seo["/about"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/about"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/about"].description
    }
    ],
    classes: "dark-page align-page-left align-items-md-center align-items-start",
    background: '#000',
  }
}, {
  path: '/en/contact',
  name: 'contact',
  component: Contact,
  meta: {
    title: window.Laravel.static_seo["/contact"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/contact"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/contact"].description
    }
    ],
    background: '#f1f1f1'
  }
}, {
  path: '/en/instagram',
  name: 'instagram',
  component: Instagram,
  meta: {
    title: window.Laravel.static_seo["/instagram"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/instagram"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/instagram"].description
    }
    ],
    classes: "align-items-start",
    background: '#fff',
  }
}, {
  path: '/en/client-area/login',
  name: 'login',
  component: Login,
  meta: {
    title: window.Laravel.static_seo["/client-area"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/client-area"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/client-area"].description
    }
    ],
    background: '#f1f1f1'
  },
}, {
  path: '/en/client-area/galleries/:category?',
  name: 'client-area',
  component: PortfolioPrivate,
  meta: {
    title: window.Laravel.static_seo["/client-area"].title,
    metaTags: [{
      name: 'description',
      content: window.Laravel.static_seo["/client-area"].description
    },
    {
      property: 'og:description',
      content: window.Laravel.static_seo["/client-area"].description
    }
    ],
    classes: "full-page",
  },
  beforeEnter: (to, from, next) => {
    if (!window.Laravel.user) {
      next({
        name: 'login'
      })
    } else {
      store.dispatch("getPrivatePortfolio")
        .then(function (response) {
          if (!to.params.category) {
            next({
              name: 'client-area',
              params: {
                category: store.getters.defaultClientPortfolioCategory
              }
            })
          } else {
            next()
          }
        })
        .catch(function (error) {
          return error
        })
    }
  }
}]